// Must be imported before @lexical/code — sets globalThis.Prism which Lexical expects at runtime.
// Without this, the production bundle fails with "Prism is not defined".
import 'prismjs'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { router } from './router'
import { ThemeProvider } from './lib/theme'
import './i18n'
import { LocaleProvider } from './i18n/locale'
import { pruneOldChatDrafts } from './lib/chat-draft-store'
import './globals.css'

// Drop chat-input drafts that haven't been touched in 30 days. Keeps
// localStorage from growing forever for users with many archived threads.
pruneOldChatDrafts(30 * 24 * 60 * 60 * 1000)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <LocaleProvider>
        <RouterProvider router={router} />
      </LocaleProvider>
    </ThemeProvider>
  </React.StrictMode>
)
